import { AIMessageContext, type AgentJsonContent } from '@diagon-alley/common';
import { useCallback, useMemo } from 'react';
import { useLocation, useParams } from 'react-router';

const useAIChatRenderContext = () => {
    const location = useLocation();
    const params = useParams();

    const getCurrentContext = useMemo(() => {
        // Simplified context mapping for diagon-alley
        // Can be extended as needed
        const homeContextMap = {
            '/home': AIMessageContext.HOME_PAGE,
        };

        for (const [path, context] of Object.entries(homeContextMap)) {
            if (location.pathname.includes(path)) {
                return context;
            }
        }

        return AIMessageContext.OTHERS;
    }, [location.pathname]);

    const getContextLocation = useCallback((jsonContent: AgentJsonContent) => {
        const context = jsonContent.value.context;
        // Simplified - can be extended based on diagon-alley routes
        switch (context) {
            case AIMessageContext.HOME_PAGE:
                return '/home';
            default:
                return null;
        }
    }, []);

    const getStateForNavigation = (jsonContent: AgentJsonContent) => {
        // Return state object for navigation
        return { aiJsonData: jsonContent };
    };

    return {
        getCurrentContext,
        getContextLocation,
        getStateForNavigation,
    };
};

export default useAIChatRenderContext;
